import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import type { SxProps, Theme } from '@mui/material/styles';

import { mergeSx } from '@/theme/mergeSx';

interface RemoveButtonProps {
  onRemove: () => void;
  ariaLabel: string;
  autoFocus?: boolean;
  size?: 'small' | 'medium' | 'large';
  edge?: 'start' | 'end' | false;
  sx?: SxProps<Theme>;
}

export const RemoveButton: React.FC<RemoveButtonProps> = ({
  onRemove,
  ariaLabel,
  autoFocus = false,
  size = 'small',
  edge = 'end',
  sx,
}) => {
  return (
    <IconButton
      onClick={onRemove}
      aria-label={ariaLabel}
      autoFocus={autoFocus}
      size={size}
      edge={edge}
      sx={mergeSx(
        {
          color: 'text.secondary',
          '&:hover': {
            color: 'error.main',
            backgroundColor: 'error.light',
            bgcolor: (theme) =>
              theme.palette.mode === 'light'
                ? 'rgba(211, 47, 47, 0.04)'
                : 'rgba(244, 67, 54, 0.08)',
          },
        },
        sx
      )}
    >
      <CloseIcon fontSize={size} />
    </IconButton>
  );
};

// Example usage variations for different contexts
export const RemoveTopicButton: React.FC<{ topic: string; onRemove: () => void }> = ({
  topic,
  onRemove,
}) => <RemoveButton onRemove={onRemove} ariaLabel={`Remove topic ${topic}`} />;
